import * as React from 'react';
import { cn } from '../../lib/utils.js';

interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        // pb-4 (was pb-5) tightens vertical rhythm so above-the-fold pages
        // (e.g. Home overview with KPIs + chart row) fit a default-zoom
        // viewport without scroll. Applied here so every page picks up
        // the same compaction without per-page edits.
        'flex flex-col gap-3 border-b pb-4 sm:flex-row sm:items-end sm:justify-between',
        className,
      )}
    >
      {/* min-w-0 lets this flex item shrink below its content's preferred
          width, which is the only way the description <p> below will wrap
          rather than overflow horizontally on narrow viewports. */}
      <div className="min-w-0 space-y-1.5">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && (
          <p className="max-w-2xl text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
